import { InAppBrowser } from "@awesome-cordova-plugins/in-app-browser/ngx";
import { Capacitor } from "@capacitor/core";
import { SharedService } from "../shared/shared.service";
import { NavigationClient } from "@azure/msal-browser";
export class CustomNavigationClient extends NavigationClient {
  constructor(private iab: InAppBrowser, private sharedService: SharedService) {
    super();
  }
  override async navigateExternal(url: string, options: any) {
    if (Capacitor.isNativePlatform()) {
      if(Capacitor.getPlatform() === 'android'){
        document.querySelector('body').style.display = 'none';
      }
      const browser = this.iab.create(url, "_blank", {
        location: "no",
        clearcache: "yes",
        clearsessioncache: "yes",
        hidenavigationbuttons: "yes",
        hideurlbar: "yes",
        fullscreen: "yes",
      });
      browser.on("loadstart").subscribe((event) => {
        if (event.url.includes("#code")) {
          // Close the in app browser and redirect to localhost + the state parameter
          browser.close();

          let baseUrl = "http://localhost/add-files";
          if (Capacitor.getPlatform() == "ios") {
            baseUrl = "capacitor://localhost/add-files";
          }

          const domain = event.url.split("#")[0];
          const url = event.url.replace(domain, baseUrl);
          window.location.href = url;
        }
      });
      browser.on("exit").subscribe(() => {
        if(Capacitor.getPlatform() === 'android'){
          document.querySelector('body').style.display = '';
        }
        this.sharedService.checkStorageAccountStatus.next(true);
      });
    } else {
      if (options.noHistory) {
        window.location.replace(url);
      } else {
        window.location.assign(url);
      }
    }
    return true;
  }
}
